<template>
  <div class="registered">
    <div class="registered_title">
      <div class="registered_title_login">
        <h2>注册</h2>
        <router-link to="/login" class="toLogin"
          >已有账号？前往登录/绑定</router-link
        >
      </div>

      <p>期待你的加入</p>
    </div>
    <div class="registered_check">
      <!-- 输入手机号，调起手机号键盘 -->
      <van-form @submit="onSubmit">
        <van-field
          @focus="isRegisted = true"
          name="username"
          :border="false"
          v-model="username"
          type="tel"
          placeholder="请输入您的手机号"
          size="18px"
        />
        <!-- :rules="[{required:true,message:'请输入正确的手机号'}]" -->
        <div class="phone">
          <van-field
            @focus="isRegisted = true"
            name="code"
            :border="false"
            v-model="code"
            center
            clearable
            placeholder="请输入您的验证码"
          >
            <template #button>
              <van-button
                size="small"
                native-type="button"
                type="primary"
                @click="sendCode(1)"
                :disabled="isSend"
                >{{ sendCodeText }}</van-button
              >
            </template>
          </van-field>
        </div>
        <!-- 输入任意文本 -->
        <van-field
          @focus="isRegisted = true"
          v-model="nickname"
          name="nickname"
          @blur="checkNickname"
          placeholder="请输入您的真实姓名"
        />
        <!-- 输入密码 -->
        <van-field
          @focus="isRegisted = true"
          @blur="checkPassword"
          class="pass"
          name="password"
          :border="false"
          v-model="password"
          :type="eyeShow ? 'text' : 'password'"
          placeholder="请输入您的密码"
          :right-icon="
            eyeShow
              ? require('../../assets/img/login_password_visible@2x.png')
              : require('../../assets/img/login_password_invisible@2x.png')
          "
          clearable
          @click-right-icon="eyeShow = !eyeShow"
        />
        <!-- 再次输入密码 -->
        <van-field
          @focus="isRegisted = true"
          @blur="checkPassword"
          class="repass"
          name="rePassword"
          :border="false"
          v-model="rePassword"
          :right-icon="
            eyeReShow
              ? require('../../assets/img/login_password_visible@2x.png')
              : require('../../assets/img/login_password_invisible@2x.png')
          "
          :type="eyeReShow ? 'text' : 'password'"
          placeholder="请再次输入您的密码"
          @click-right-icon="eyeReShow = !eyeReShow"
        />
        <div class="registered_button">
          <van-button
            round
            type="info"
            native-type="submit"
            :class="isRegisted ? 'activeRegiste' : ''"
            >注册</van-button
          >
          <div class="argee" @click="toAgreement()">
            注册即同意<span style="color: #93683d">《用户协议》</span>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import Title from "../../components/Title";
import { getRegisterCode, getUserRegistered } from "@/api/home.js";
import { Toast } from "vant";
export default {
  components: {
    Title,
  },
  data() {
    return {
      isSend: false,
      sendCodeText: "发送验证码",
      isRegisted: false,
      username: "",
      password: "",
      rePassword: "",
      code: "",
      nickname: "",
      eyeShow: false,
      eyeReShow: false,
      timer: null,
      timeNum: 60,
    };
  },
  methods: {
    toAgreement() {
      // window.location.href = this.commonRealmName +
      //   "/index.php/main/news_show/id/1";
      this.$router.push({
        name: "文章详情",
        params: {
          id: 1,
          article: {
            title: "《用户协议》",
          },
        },
      });
    },
    checkNickname() {
      const reg = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/;
      if (this.nickname) {
        if (this.nickname.match(reg)) {
        } else {
          Toast("请输入真实姓名");
        }
      } else {
        Toast("姓名不能为空");
      }
    },
    // 检测手机号的格式
    isvalidatemobile(phone) {
      const list = [];
      let result = true;
      let msg = "";
      var isPhone = /^1[3456789]\d{9}$/;
      if (phone.length == 11) {
        if (!isPhone.test(phone)) {
          msg = "手机号码格式不正确";
          result = false;
        }
      } else {
        msg = "手机号码长度不为11位";
        result = false;
      }
      list.push(result);
      list.push(msg);
      return list;
    },
    // 检测两次密码是否一致,检测密码长度是否符合规范6-12位
    checkPassword() {
      const reg = /^[\w]{6,12}$/;
      if (this.password) {
        if (this.password.match(reg)) {
          if (this.password && this.rePassword) {
            if (this.password != this.rePassword) {
              Toast("两次输入的密码不一致");
            }
          }
        } else {
          Toast("请输入6-12位密码");
        }
      }
    },
    // 发送验证码
    sendCode(val) {
      if (this.username) {
        // 判断手机号是否符合规范
        const validate = this.isvalidatemobile(this.username);
        if (validate[0]) {
          getRegisterCode({ phone: this.username, type: val })
            .then((res) => {
              Toast("发送成功");
              this.setTimeFn();
            })
            .catch((err) => {
              Toast("发送失败请重新发送");
            });
        } else {
          Toast(validate[1]);
        }
      } else {
        Toast("请输入手机号");
      }
    },
    // 发送验证码之后的倒计时
    setTimeFn() {
      setTimeout(() => {
        this.isSend = true;
        this.timeNum -= 1;
        this.sendCodeText = "重新获取(" + this.timeNum + ")";
        if (this.timeNum == 0) {
          this.isSend = false;
          this.timeNum = 60;
          this.sendCodeText = "发送验证码";
        } else {
          this.setTimeFn();
        }
      }, 1000);
    },
    // 点击注册按钮
    onSubmit(val) {
      if (
        this.username == "" ||
        this.password == "" ||
        this.rePassword == "" ||
        this.nickname == "" ||
        this.code == ""
      ) {
        Toast("请正确填写");
      } else {
        if (localStorage.getItem("otheraid")) {
          val.aid = localStorage.getItem("otheraid");
        } else {
          val.aid = 0;
        }
        getUserRegistered(val)
          .then((res) => {
            if (res.data.code == 0) {
              Toast(res.data.msg);
              localStorage.setItem("userToken", res.data.backdata.token);
              setTimeout(() => {
                this.$router.push("/home");
              }, 1000);
            } else {
              Toast(res.data.msg);
            }
          })
          .catch((err) => {});
      }
    },
  },
  beforeDestroy() {
    clearTimeout();
  },
};
</script>

<style lang='scss'>
.registered {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  background: url("../../assets/img/login_bg@2x.png") no-repeat;
  background-size: 100% 100%;
  // 标题部分
  .registered_title {
    width: 100%;
    height: 1.53rem;
    margin-bottom: 0.42rem;
    padding: 1.01rem 0.15rem 0 0.15rem;
    .registered_title_login {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      h2 {
        height: 0.23rem;
        font-size: 0.23rem;

        font-weight: bold;
        color: #93683d;
        line-height: 0.2rem;
        margin-bottom: 0.1rem;
      }
      .toLogin {
        font-size: 0.14rem;

        font-weight: bold;
        text-decoration: underline;
        color: #333333;
        line-height: 0.2rem;
        margin-bottom: 0.1rem;
      }
    }
    p {
      font-size: 0.12rem;

      color: #999a9c;
      margin-left: 0.01rem;
    }
  }
  // 验证部分
  .registered_check {
    padding: 0 0.15rem;
    .van-field {
      padding: 0px;
      width: 100%;
      height: 0.44rem;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(0, 83, 16, 0.04);
      border-radius: 0.08rem;
      margin-bottom: 0.22rem;
      .van-field__body {
        padding: 0 0.14rem;
        .van-field__button {
          .van-button--primary {
            background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
            border-radius: 8px;
            border: none;
            width: 1rem;
            height: 0.29rem;
            color: #93683d;
            font-size: 0.14rem;

            line-height: 0.2rem;
          }
        }
        .van-field__control {
          height: 0.44rem;
          line-height: 0.44rem;
          font-size: 0.14rem;
        }
        input::input-placeholder {
          color: #999a9c;
        }
        input::-webkit-input-placeholder {
          color: #999a9c;
        }
        input:-moz-placeholder {
          color: #999a9c;
        }
        input::-moz-placeholder {
          color: #999a9c;
        }
        input:-ms-input-placeholder {
          color: #999a9c;
        }
      }
    }
  }
  // 底部按钮部分
  .registered_button {
    width: 100%;
    height: 1.4rem;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .van-button {
      width: 2.72rem;
      height: 0.44rem;
      border: none;
      font-size: 0.16rem;

      font-weight: bold;
      background: #999a9c;
      margin-top: 0.22rem;
      margin-bottom: 0.1rem;
      box-shadow: 0px 5px 10px 0px rgba(0, 83, 16, 0.04);
      &.activeRegiste {
        color: #93683d !important;
        background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      }
    }
    .argee {
      height: 0.18rem;
      line-height: 0.18rem;
      font-size: 0.12rem;

      font-weight: bold;
      color: #333333;
    }
  }
}
</style>
